
/* THE MYTH — CART UPSELL */

(() => {
  let requestId = 0;

  async function loadUpsell() {
    const container = document.querySelector(
      'cart-drawer .myth-cart-upsell'
    );

    if (!container) return;

    const productId = container.dataset.productId;
    const target = container.querySelector(
      '.myth-cart-upsell__products'
    );

    if (!productId || !target) return;

    const currentRequest = ++requestId;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const url = new URL(
        `${root}recommendations/products`,
        window.location.origin
      );

      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set(
        'section_id',
        'themyth-cart-recommendations'
      );

      const response = await fetch(url);

      if (!response.ok) throw new Error('Recommendations failed');

      const html = await response.text();

      if (currentRequest !== requestId) return;
      if (!container.isConnected) return;

      const documentFragment = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const product = documentFragment.querySelector(
        '.myth-upsell-product'
      );

      if (product) {
        target.replaceChildren(product);
        container.hidden = false;
      } else {
        target.replaceChildren();
        container.hidden = true;
      }
    } catch (error) {
      console.warn('THE MYTH upsell:', error);
    }
  }

  async function addUpsell(button) {
    const product = button.closest('.myth-upsell-product');
    const select = product?.querySelector(
      '.myth-upsell-product__variant'
    );

    if (!select?.value) {
      select?.focus();
      return;
    }

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(select.value),
            quantity: 1
          }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Could not add product');
      }

      const drawer = document.querySelector('cart-drawer');

      if (drawer && data.sections) {
        drawer.renderContents({
          ...data,
          id: data.items?.[0]?.id
        });
      }

    } catch (error) {
      alert(error.message);
    } finally {
      button.disabled = false;
      button.textContent = 'ADD TO CART';
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '.myth-upsell-product__add'
    );

    if (button) addUpsell(button);
  });

  const observer = new MutationObserver(() => {
    const container = document.querySelector(
      'cart-drawer .myth-cart-upsell'
    );

    if (container && !container.dataset.loaded) {
      container.dataset.loaded = 'true';
      loadUpsell();
    }
  });

  function init() {
    const drawer = document.querySelector('cart-drawer');

    if (!drawer) return;

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });

    const container = drawer.querySelector('.myth-cart-upsell');

    if (container) {
      container.dataset.loaded = 'true';
      loadUpsell();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
